module.exports = __webpack_public_path__ + "static/media/capsules.8d5c266b.svg";